<template>
  <el-dialog
    custom-class="import-dialog"
    title="添加商品"
    :visible="visible"
    @close="close"
    width="1000px"
  >
    <div class="p20">
      <div class="table-panel flex flex-between">
        <div class="flex-1 text-right">
          <el-cascader
            v-model="searchCondition.categoryId"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="categoryFunc"
            clearable
            placeholder="请选择类目"
          ></el-cascader>
          <el-cascader
            v-model="searchCondition.attributeId"
            placeholder="请选择辅助属性"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="attributeFunc"
            clearable
          ></el-cascader>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.keyWords"
            size="small"
            :placeholder="placeholder"
            class="ipt mr10"
          >
            <el-select
              slot="prepend"
              size="small"
              style="width:100px"
              @change="selectQueryType"
              v-model="searchCondition.queryType"
            >
              <el-option label="商品名" value="spu_name"></el-option>
              <el-option label="货号" value="goods_sn"></el-option>
              <el-option label="条码" value="spec_barcode"></el-option>
              <el-option label="品牌名" value="brand_name"></el-option>
            </el-select>
          </el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <el-button type="info" size="small" @click="searchCondition = {}"
            >重置</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          stripe
          border
          ref="brandTable"
          @current-change="handleCurrentChange"
          highlight-current-row
          @selection-change="getChecked"
          :data="mallGoodsList.records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSnAndBarcode"
            show-overflow-tooltip
            label="商品编码/条码"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="是否虚拟商品"
          ></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            label="商品类目(所属末级)"
          ></el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="mallGoodsList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      placeholder: "请输入商品名",
      currentRow: {},
      tHeader: [],
      tBody: [],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      batchCondition: {
        oldWord: "",
        newWord: "",
        categoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {
        queryType: "spu_name"
      },
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: mapGetters([
    "mallGoodsList",
    "salesChannels",
    "allMallGoodsList",
    "goodsDetails"
  ]),
  watch: {
    goodsDetails(val) {
      if (val) {
        this.$emit("setGoodsInfo", val);
        this.close();
      }
    },
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  created() {},
  mounted() {
    this.$store.dispatch("querySalesChannels");
    this.queryList();
  },
  methods: {
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    save() {
      if (!this.currentRow.spuId) {
        this.$message({
          type: "warning",
          message: "请先选择商品"
        });
      } else {
        this.$store.dispatch("queryGoodsDetails", {
          spuId: this.currentRow.spuId
        });
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    close() {
      this.$emit("close");
    },
    submitRuleForm() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.categoryId =
        batchCondition.categoryId[batchCondition.categoryId.length - 1];
      batchCondition.spuIdList = this.checkedRow;
      this.$store.dispatch("batchEdit", batchCondition).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      });
    },
    addGoods() {
      this.$router.push({ name: "AddGoods" });
    },
    edit(row) {
      this.$router.push({
        name: "EditGoods",
        query: {
          spuId: row.spuId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        isWxshop: "yes"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      Object.assign(params, searchCondition);
      const actionName = queryAll
        ? "queryAllMallGoodsList"
        : "queryMallGoodsList";
      return this.$store.dispatch(actionName, params);
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
